import React, { ReactElement } from 'react';
import {Row, Col} from 'antd';
import CPieChart from '../CPieChart';
import './reimbursement-chart.less';
import { authFeatureConstants } from '../../../constants/commonConstants';
import { canActivate } from '../../../../utils/utility';

const ReimbursementChart = ({title, chartData}: any): ReactElement => {
  const data = [
    { title: 'Reimbursement', value: chartData?.reimbursementClaimCount, color: '#6664D7' },
    { title: 'Cashless', value: chartData?.cashlessClaimCount, color: '#D0CFFF' },
  ];

  return (
    <>
      <Row className="heading">
        <Col>{title}</Col>
      </Row>
      <CPieChart
        data={data}
        hideLabels={
          canActivate(
            authFeatureConstants.IS_HIDE_REIMBURSEMENT_LABEL,
          )
        }
      />
    </>
  );
};

export default ReimbursementChart;
